import { AppliedFilterMapping } from '@/pages/DataBrowser/dataBrowserState';

import { createAtom } from '../utils';

export type AppliedFiltersMapping = {
  [version: number | string]: AppliedFilterMapping;
};
export const appliedFiltersAtom = createAtom<AppliedFiltersMapping>('appliedFilters', {});
